import { CREDENTIAL_LABEL_SOURCE_MANUAL } from '@shared/schema/credentialLabelSource.js';
import { getConnections } from '@/redux/requests/connectionsRequests.js';
import testCompanyCredential from '@/redux/requests/credentials/testCompanyCredential.js';
import upsertCompanyCredential from '@/redux/requests/credentials/upsertCompanyCredential.js';

/**
 * Saves a connection from the connect form, then asks the app whether the values work. A rejected
 * connection stays saved as not working, so the person can fix the values and try again on the same
 * one (`credentialId`). Returns the saved id and, when the app said no, the app's own reason.
 */
const connectApp = ({ app, auth, values, label, credentialId = null }) => {
  return async () => {
    const name = String(label || '').trim() || app.name;
    const saveRes = await upsertCompanyCredential({
      appId: app.id,
      credentialId: credentialId || undefined,
      secrets: { ...values, type: auth.type, authId: auth.id, label: name },
      meta: { label: name, labelSource: CREDENTIAL_LABEL_SOURCE_MANUAL, type: auth.type, authId: auth.id },
      source: 'pieve-web-connect'
    });

    if (saveRes?.success === false) {
      return { success: false, stage: 'save', message: saveRes.message || 'The connection could not be saved.' };
    }

    const savedId = saveRes?.credentialId || credentialId;

    if (auth.type === 'none') {
      await getConnections();
      return { success: true, credentialId: savedId };
    }

    const testRes = await testCompanyCredential({ credentialId: savedId, appId: app.id, appVersion: app.version });
    await getConnections();

    if (testRes?.success === false) {
      return { success: false, stage: 'check', credentialId: savedId, message: testRes.message || `${app.name} did not accept these details.` };
    }

    return { success: true, credentialId: savedId };
  };
};

export default connectApp;
